<ng-container *transloco="let t">
  <app-overdue-amazon-invoice-warning withLinkToInvoicePage></app-overdue-amazon-invoice-warning>
  <div class="flex flex-col gap-3">
    <app-compact-filter [filters]="filters()" (filterChange)="applyFilter($event)" />

    <app-metric-selector
      [data]="totalData()"
      [previousPeriodData]="previousTotalData()"
      [localStorageKey]="localstorageKey"
      (selectedMetricsChange)="chartMetrics.set($event)"
      [availableMetrics]="dspMetrics"
      [dataLoading]="dataLoading()"
    />

    @if (globalChartDisplay()) {
      <app-chart-layout
        withDateAggregation
        closable
        [dataLoading]="dataLoading()"
        (closeClicked)="toggleGlobalChartDisplay(false)"
        (aggregationChange)="dateAggregation.set($event)"
      >
        <IChart [config]="chartConfig()" [data]="globalDatasetData()" />
      </app-chart-layout>
    } @else {
      <div class="flex justify-end">
        <button iButton variant="secondary" (click)="toggleGlobalChartDisplay(true)">
          <IIcon name="chartLine" />
          {{ t("common.show_chart") }}
        </button>
      </div>
    }

    <app-grid-layout
      [withExport]="true"
      (export)="exportCampaignGridCsv()"
      [withRestoreColumns]="true"
      (columnRestore)="restoreCampaignGridColumns()"
    >
      <ag-grid-angular
        class="h-[40vh] w-full"
        #campaignStatsGrid
        [rowData]="campaignStatsGridData()"
        [gridOptions]="campaignStatsGridOptions"
        [animateRows]="true"
      />
    </app-grid-layout>

    <app-grid-layout
      [withExport]="true"
      (export)="exportCreativeGridCsv()"
      [withRestoreColumns]="true"
      (columnRestore)="restoreCreativeGridColumns()"
    >
      <ag-grid-angular
        class="h-[40vh] w-full"
        #creativeStatsGrid
        [rowData]="creativeStatsGridData()"
        [gridOptions]="creativeStatsGridOptions"
        [animateRows]="true"
      />
    </app-grid-layout>
  </div>
</ng-container>
